import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { FilterByPipe, IsTodayPipe, LocaleDatePipe, MomentStartDayPipe, ObjKeysPipe } from './pipes';
import { ConfirmationDialogComponent, DataCollectingConfirmationDialogComponent } from './components';
import { AutoFocusDirective } from './directives';
import { ChecklistSignatureComponent } from '../protocols/components/signature/checklist-signature.component';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ServiceWorkerModule.register('ngsw-worker.js'),
    AngularFireAuthModule,
    AngularFireMessagingModule,
    ReactiveFormsModule,
    ZenithComponentsModule,
    LocaleDatePipe
  ],
  declarations: [
    MomentStartDayPipe,
    ObjKeysPipe,
    FilterByPipe,
    IsTodayPipe,
    EllipsisPipe,
    AutoFocusDirective,
    ConfirmationDialogComponent,
    DataCollectingConfirmationDialogComponent,
    ChecklistSignatureComponent
  ],
  exports: [
    MomentStartDayPipe,
    ObjKeysPipe,
    FilterByPipe,
    LocaleDatePipe,
    IsTodayPipe,
    EllipsisPipe,
    AutoFocusDirective,
    ReactiveFormsModule,
    ChecklistSignatureComponent
  ]
})
export class SharedModule {}
